import React from 'react';
import Navbar from './global-components/navbar';
import PageHeader from './global-components/page-header';
import TamilNaduOpenUniversityDetails from './section-components/tamilnadu-open-university-details';
import Footer from './global-components/footer-v2';
import {Helmet} from "react-helmet";

const TamilNaduOpenUniversity = () => {
    return <div>
        <Navbar />
        <Helmet>
            <title>Open and Distance Learning Education Provider | MIET Chennai</title>
            <meta name="description" content="MIET offers Open and Distance Learning Education for UG programmes in engineering, management, science besides masters programme in Maths, Physics, Chemistry." />
        </Helmet>
        <PageHeader headertitle="Tamil Nadu Open University"  />
        <TamilNaduOpenUniversityDetails />
        <Footer />
    </div>
}

export default TamilNaduOpenUniversity